import React from 'react';
import { observer } from 'mobx-react';
import { Box, Grid, List, ListItem, makeStyles, Paper, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import moment from 'moment';

import { useStores } from '../../hooks/use-stores';

const Delivery = observer(() => {
    const theme = useTheme();
    const isLG = useMediaQuery(theme.breakpoints.down('lg'));

    const classes = useStyles();
    const { ProfileOrderStore: { order } = {} } = useStores();
    const {
        delivery,
        delivery_params: {
            return_method,
            delivery_date,
            tc_name,
            delivery_status_percent,
            return_status_percent,
            shipment_date,
            return_date,
        } = {},
    } = order || {};

    return (
        <Grid container className={isLG ? classes.center : ''} spacing={2} mb={2}>
            <Grid item key={tc_name} sm={6} xs={10}>
                <List>
                    <Paper>
                        <ListItem className={classes.listItem}>
                            <Typography className={classes.specs}>Тип доставки</Typography>
                            <Box align="right">
                                <Typography className={classes.data}>{delivery ? delivery : 'Не указано'}</Typography>
                            </Box>
                        </ListItem>

                        <ListItem className={classes.listItem}>
                            <Typography className={classes.specs}>Дата доставки</Typography>
                            <Typography className={classes.data}>
                                {delivery_date ? moment(delivery_date).format('D.M.Y') : 'Не указано'}
                            </Typography>
                        </ListItem>

                        <ListItem className={classes.listItem}>
                            <Typography className={classes.specs}>Транспортная компания</Typography>
                            <Typography className={classes.data}>{tc_name ? tc_name : 'Не указано'}</Typography>
                        </ListItem>

                        <ListItem className={classes.listItem}>
                            <Typography className={classes.specs}>Отгрузка</Typography>
                            <div
                                style={{ border: '2px solid #34C99C', borderRadius: '50%', width: '18px', height: '18px' }}
                                className={`ellipse--${delivery_status_percent}`}
                            />
                        </ListItem>

                        <ListItem className={classes.listItem}>
                            <Typography className={classes.specs}>Дата отгрузки</Typography>
                            <Typography className={classes.data}>
                                {shipment_date ? moment(shipment_date).format('D.M.Y') : 'Не указано'}
                            </Typography>
                        </ListItem>

                        <ListItem className={classes.listItem}>
                            <Typography className={classes.specs}>Возврат</Typography>
                            <div
                                style={{ border: '2px solid #34C99C', borderRadius: '50%', width: '18px', height: '18px' }}
                                className={` ellipse--${return_status_percent}`}
                            />
                        </ListItem>

                        <ListItem className={classes.listItem}>
                            <Typography className={classes.specs}>Способ возврата</Typography>
                            <Typography className={classes.data}>{return_method ? return_method : 'Не указано'}</Typography>
                        </ListItem>

                        <ListItem className={classes.listItem}>
                            <Typography className={classes.specs}>Дата возврата</Typography>
                            <Typography className={classes.data}>
                                {return_date ? moment(return_date).format('D.M.Y') : 'Не указано'}
                            </Typography>
                        </ListItem>
                    </Paper>
                </List>
            </Grid>
        </Grid>
    );
});

const useStyles = makeStyles({
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    specs: {
        fontWeight: 'bold',
        color: '#777777',
        fontSize: '14px',
    },
    data: {
        color: '#3a3a3a',
        fontSize: '14px',
    },
    center: {
        justifyContent: 'center',
    },
});

export default Delivery;
